// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] || chunkId) + "." + {"50":"9fcf5a824e56ad03","133":"3d371595d100e11f","835":"12f2bfcb9226cf69","898":"fd8bfa2092c915b5"}[chunkId] + ".js";
};